import scrollToBar from "../../../Task/types/Common/scrollToBar";
import handleTouch from "../../../../../common/helpers/handleTouch";

import { handleRhythmChange } from "./handleRhythmChange";
import { IBar, INote, IScoreEditorThis } from "../../../../../common/types";
import { SyntheticEvent } from "react";
import { getBarTotalLength } from "./getBarTotalLength";
import { getRealLength } from "./getRealLength";

export const handleRhythmInput = async function (this: IScoreEditorThis, rhytLength: INote["l"], e: KeyboardEvent | MouseEvent | TouchEvent) {
  if (!(await handleTouch(e))) return;
  const { restMode, activeVoice } = this.state;
  const score = { ...this.state.score };
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  if (this.state.selectedNote && bars[this.state.selectedNote.bar]?.notes?.[this.state.selectedNote.note])
      return handleRhythmChange.call(this, rhytLength);
  let { trupletLeft } = score;
  let currentBarIndex = bars.length - 1;
  let currentBar = bars[currentBarIndex];
  let nextNoteIndex = currentBar.notes.length;

  let barTotalLength = getBarTotalLength(score.signatures, currentBarIndex) * 3;
  let barLength = 0;
  if (currentBar.notes.length) {
      // add trumplet here
      barLength = currentBar.notes
          .map((note, index) => {
              let noteLength = getRealLength(note) * (note.t ? 2 : 3);
              return noteLength;
          })
          .reduce((total, next) => total + next);
  }
  let truplet = false;
  let trupletStart = false;
  if (trupletLeft) {
      truplet = true;
      if (trupletLeft === 3) trupletStart = true;
      trupletLeft -= (4 / rhytLength) * 2;
  }
  if (barTotalLength < barLength + (4 / rhytLength) * (truplet ? 2 : 3)) return this.setState({ fullBar: true });
  let noteLength = (4 / rhytLength) * (truplet ? 2 : 3);
  barLength += noteLength;
  let note: INote = {
      l: rhytLength,
  };
  if (truplet) note.t = 1;
  if (trupletStart) note.ts = 1;
  currentBar.notes.push(note);
  if (restMode) {
      currentBar.notes[nextNoteIndex].r = 1;
  }
  if (barTotalLength === barLength) {
      // new bars
      bars.push({
          notes: [],
      });
  }
  score.trupletLeft = trupletLeft;
  this.setState({ score, fullBar: false }, () => {
      scrollToBar(this.distribution, this.scoreRef, currentBarIndex);
  });
};
